module.exports = __webpack_public_path__ + "static/media/011-call-center-1.e0e5fa27.svg";